import React, { useEffect } from "react";
import { Box, Typography, CircularProgress, Grid } from "@mui/material";
import { usetStatisticsStore } from "store/StatisticsStore";
import StatsCard from "./StatsCard";

const StatsTab = () => {
    const { loading, statistics, fetchStatistics } = usetStatisticsStore();
    const error = null
    
    useEffect(() => {
        fetchStatistics();
      }, [fetchStatistics]);
    
    return (
        <Box>  
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : statistics ? (
          <Grid container spacing={2}>
            {Object.entries(statistics).map(([ext, data]) => (
              <Grid item xs={12} sm={6} md={2.4} key={ext}>
                <StatsCard
                  extension={ext}
                  total={data.total}
                  available={data.available}
                  available_p={data.available_p}
                  total_size={data.total_size}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography>No data available.</Typography>
        )}
      </Box>
    );
};

export default StatsTab;
